$ = jQuery.noConflict()

const fundingForm = () => {


  $('[data-funding-form]').on('click', function (e) {
    e.preventDefault()
    $('.c-funding-modal').animate({
      scrollTop: 0,
    }, 500)
    const target = $(this).attr('data-funding-form')
    $('.apply__funding-form').hide()
    $('.c-package, .c-funding-modal__title').hide()
    $(`#${target}`).fadeIn()
  })

  $('[go-back]').on('click', (e) => {
    e.preventDefault()
    $('.c-package, .c-funding-modal__title').fadeIn()
    $('.c-apply__funding-form').fadeOut()
  })

  $('.generated-design').each(function () {
    $(this).on('change', (e) => {

      const productID = $(this).closest('.c-form--apply').find('[data-product-id]').val()
      const select = e.target
      const option = select.options[select.selectedIndex]

      if (!$(option).hasClass('gf_placeholder')) {
        const target = $(option).text()
        $(`#${productID}-tshirt-default`).hide()
        $('.c-form__images-hidden img').hide()
        $(`#${productID}-tshirt-${target}`).fadeIn()
      } else {
        $('.c-form__images-hidden img').hide()
        $(`#${productID}-tshirt-default`).fadeIn()
      }

    })
  })
}

export default fundingForm
